module.exports = __webpack_public_path__ + "static/media/first-reward.a4cecbfe.svg";